import React from 'react';

import './JobResultsShineComponent.scss';

export default class JobResultsShineComponent extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="component-ShineComponents-JobResultsShineComponent">
                <div className="animated-background">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 540 440"
                    >
                        <defs />
                        <path
                            fill="#FFF"
                            d="M540 0v440H0V0h540zM81 353H21v60h60v-60zm381 28H102a3 3 0 00-3 3v12a3 3 0 003 3h360a3 3 0 003-3v-12a3 3 0 00-3-3zm54-28H102a3 3 0 00-3 3v12a3 3 0 003 3h414a3 3 0 003-3v-12a3 3 0 00-3-3zM81 274H21v60h60v-60zm381 28H102a3 3 0 00-3 3v12a3 3 0 003 3h360a3 3 0 003-3v-12a3 3 0 00-3-3zm54-28H102a3 3 0 00-3 3v12a3 3 0 003 3h414a3 3 0 003-3v-12a3 3 0 00-3-3zM81 190H21v60h60v-60zm381 28H102a3 3 0 00-3 3v12a3 3 0 003 3h360a3 3 0 003-3v-12a3 3 0 00-3-3zm54-28H102a3 3 0 00-3 3v12a3 3 0 003 3h414a3 3 0 003-3v-12a3 3 0 00-3-3zM81 106H21v60h60v-60zm381 28H102a3 3 0 00-3 3v12a3 3 0 003 3h360a3 3 0 003-3v-12a3 3 0 00-3-3zm54-28H102a3 3 0 00-3 3v12a3 3 0 003 3h414a3 3 0 003-3v-12a3 3 0 00-3-3zM81 22H21v60h60V22zm381 28H102a3 3 0 00-3 3v12a3 3 0 003 3h360a3 3 0 003-3V53a3 3 0 00-3-3zm54-28H102a3 3 0 00-3 3v12a3 3 0 003 3h414a3 3 0 003-3V25a3 3 0 00-3-3z"
                        />
                    </svg>
                </div>
            </div>
        );
    }
}
